// @flow

export const color: { [string]: string } = {
  // light shades
  white: '#FFFFFF',
  snow: '#F9FAFC',
  darkSnow: '#EFF2F7',
  extraDarkSnow: '#E5E9F2',
  // dark tones
  silver: '#8492A6',
  slate: '#3C4858',
  steel: '#273444',
  black: '#1F2D3D',
  // dark shades
  smoke: '#E0E6ED',
  darkSmoke: '#D3DCE6',
  extraDarkSmoke: '#C0CCDA',
  // blue shades
  lightBlue: '#85D7FF',
  blue: '#1FB6FF',
  darkBlue: '#009EEB',
  // purple shades
  lightPurple: '#A389F4',
  purple: '#7E5BEF',
  darkPurple: '#592DEA',
  // pink shades
  lightPink: '#FF7CE5',
  pink: '#FF49DB',
  darkPink: '#FF16D1',
  // orange shades
  lightOrange: '#FF9E7C',
  orange: '#FF7849',
  darkOrange: '#FF5216',
  // green shades
  lightGreen: '#29EB7F',
  green: '#13CE66',
  darkGreen: '#0F9F4F',
  // yellow shades
  lightYellow: '#FFD55F',
  yellow: '#FFC82C',
  darkYellow: '#F8B700',
  // ui colors
  info: '#3FA8F0',
  success: '#0ABD63',
  danger: '#F07B7B',
  warning: '#ECB33D',
  default: '#333333',
  disabled: '#979797',
  sideNav: '#354053',
  logout: 'linear-gradient(-135deg, #622774 0%, #C53364 100%)',
  sideNavSelected: '#242C33',
  gradient: 'linear-gradient(-45deg, #1BCEDF 0%, #5B247A 100%)',
  blueBody: '#EDF2F8',
  berryGradient: 'linear-gradient(-225deg, #622774 0%, #C53364 100%)',
  grayBorder: '#CECECE',
  tabs: '#2196F3',
  mobileAppName: '#172B4D',
  tabDefault: '#fafbfd'
}

export default color
